/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { memo } from 'react';
import styled from 'styled-components';

import { translate } from '../../../../common/translation/translate';
import { mediumMediaQuery, smallMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { AqiNoDataIcon } from '../../../common/icons/aqiNoDataIcon';
import { CommonErrorUIProps } from '../types';
import { 
    Container,
    MapStoriesViewNoDataBodyText,
    MapStoriesViewNoDataHeaderText,
    MapStoriesViewNoDataHeaderTextIconWrapper, 
    IconWrapper, 
    NoDataBodyText, 
    NoDataHeaderText, 
    NoDataHeaderTextIconWrapper } from './commonErrorStyles';

interface NoAqiDataUIProps extends CommonErrorUIProps {
    isHealthAdvice?: boolean;
}

export const NoAqiDataUI = memo(({ isHealthAdvice, isMap }: NoAqiDataUIProps) => {
    if (isMap) {
        return (
            <MapViewContainer>
                <MapStoriesViewNoDataHeaderTextIconWrapper>
                    <IconWrapper isMapOrStoriesView={isMap}>
                        <AqiNoDataIcon />
                    </IconWrapper>
                    <MapStoriesViewNoDataHeaderText>{translate('noDataAvailable')}</MapStoriesViewNoDataHeaderText>
                </MapStoriesViewNoDataHeaderTextIconWrapper>
                <MapStoriesViewNoDataBodyText>{translate('noDataInLocationMessage')}</MapStoriesViewNoDataBodyText>
            </MapViewContainer>
        );
    }
    return (
        <Container isHealthAdvice={isHealthAdvice} >
            <NoDataHeaderTextIconWrapper>
                <IconWrapper>
                    <AqiNoDataIcon />
                </IconWrapper>
                <NoDataHeaderText>{translate('noDataAvailable')}</NoDataHeaderText>
            </NoDataHeaderTextIconWrapper>
            <NoDataBodyText>{translate('noDataInLocationMessage')}</NoDataBodyText>
        </Container>
    );
});

NoAqiDataUI.displayName = 'NoAqiDataUI';

const MapViewContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #F9F9F9;
    width: 72%;
    margin-left: 10px;
    padding-right: 0;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 600px;
    @media ${mediumMediaQuery} {
        width: 52%;
    }
    @media ${smallMediaQuery} {
        margin: 10px 0 0 0;
        height: 400px;
        width: 100%;
    }
`;
